var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

            $(window).on('resize',function(){
                if ($(window).width() > 991){
                    if ( swiper !== undefined ) swiper.destroy( true, true );
                } else {
                    enableSwiper();
                }
            });

            const enableSwiper = function() {
                swiper = new Swiper ('.block-title-2-columns-cards .swiper-container', {
                    slidesPerView: 'auto',
                    speed: 400,
                    spaceBetween: 0,
                    initialSlide: 0,
                    navigation: {
                        nextEl: '.block-title-2-columns-cards .swiper-button-next',
                        prevEl: '.block-title-2-columns-cards .swiper-button-prev',
                    }
                });
            };

            if ($(window).width() <= 991){
                enableSwiper();
            }

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=title-2-columns-cards', initializeBlock);
    }
});
